import { Helmet } from 'react-helmet-async';
import React from 'react';
import Header from '../Common/Header';
import Footer from '../Common/Footer';
import Banner from '../Elements/Banner';
import ProductsSection from '../Elements/ProductsSection';
import ClientsLogo from '../Elements/ClientsLogo';
import '../../styles/pages/Products.css';

var bnrimg = require('./../../images/banner/6.jpg');


class Products extends React.Component {
    render() {
        return (
            <>
                <Helmet>
                    <title>bs clads</title>
                    <meta name="description" content="Explore our comprehensive range of high-performance architectural ACP Front Elevation, Facade Glazing, and Toughened Glass solutions by bs clads." />
                </Helmet>
                <Header />
                <div className="page-content">
                    <Banner title="Our Products" pagename="Products" description="Explore our comprehensive range of high-performance architectural ACP Front Elevation, Facade Glazing, and Toughened Glass solutions by bs clads." bgimage={bnrimg}/>
                    <ProductsSection />
                    <ClientsLogo />
                </div>
                <Footer />
            </>
        );
    }
}

export default Products;
